<template>
  <div class="login">
    <!-- 登录 -->
    <el-dialog title="账号登录" v-if="show == 'login'" :visible.sync="loginVisible" :before-close="handleClose" center
      width="550px">
      <el-form style="margin: 50px auto;;width:400px" :model="ruleForm" :rules="rules" ref="forruleFormm" label-width="0"
        size="large">
        <el-form-item prop="user">
          <el-input v-model="ruleForm.user" prefix-icon="el-icon-user" clearable placeholder="用户名">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="ruleForm.password" prefix-icon="el-icon-lock" clearable show-password
            placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="width: 100%;margin-top:20px" :loading="islogin" round @click="login">登
            录</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 注册 -->
    <el-dialog title="注册账户" v-if="show == 'register'" :visible.sync="loginVisible" :before-close="handleClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="40%" center>
      <el-form style="margin-top: 40px" label-position="left" :model="regForm" :rules="regRules" ref="form"
        label-width="80px" size="large">
        <el-form-item label="手机号">
          <el-input v-model="regForm.tel" clearable></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input v-model="regForm.code" clearable></el-input>
          <div style="float: right">
            <el-link type="primary" @click="getCode1">获取手机验证码</el-link>
          </div>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input type="password" v-model="regForm.pass" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="regForm.checkPass" show-password clearable></el-input>
        </el-form-item>
        <div class="clause mar-top-30 fs16 flex">
          <div class="select cur-poi" :class="read ? 'active' : ''" @click="select"></div>
          <span class="mar-left-5">创建账号代表您已接受YSHOP</span>
          <span class="mar-left-5 underline cur-poi">隐私条款</span>
        </div>
        <el-form-item>
          <!-- <el-button type="primary" @click="success">登入</el-button> -->
          <el-button type="warning" style="width: 100%; margin-top: 30px" :loading="islogin" round @click="register">立即注册
          </el-button>
        </el-form-item>
      </el-form>

      <div style="float: right">
        <el-link @click="toLogin" type="success">已注册,立即登入</el-link>
      </div>
    </el-dialog>
    <!-- 忘记密码 -->
    <el-dialog title="找回密码" v-if="show == 'forgot'" :visible.sync="loginVisible" :before-close="handleClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="35%" center>
      <div class="mar-top-40">
        <div class="phoneNumber">
          <div class="fs18">
            <span>手机号<span class="fr">已有账号，<span class="underline fr cur-poi" @click="toLogin">去登录</span></span></span>
          </div>
          <input class="mar-top-20" v-model="phoneNumber2" type="number" />
        </div>
        <div class="password mar-top-40">
          <p class="fs18">手机验证码</p>
          <div class="display-between mar-top-20">
            <input style="width: 60%" v-model="authCode2" type="text" />
            <span v-if="showTime2" class="underline fs16" style="line-height: 40px">{{ time2 }}s</span>
            <span v-else class="underline cur-poi fs16" style="line-height: 40px" @click="getCode2">获取手机验证码</span>
          </div>
        </div>
        <div class="password mar-top-40">
          <p class="fs18">密码</p>
          <input class="mar-top-20" v-model="pwd2" type="text" />
        </div>
        <div class="password mar-top-40">
          <p class="fs18">确认密码</p>
          <input class="mar-top-20" v-model="pwdAgain1" type="text" />
        </div>
        <div class="btn mar-top-40">
          <el-button :loading="loading2" plain @click="getBack">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from "js-cookie";
import { mapGetters, mapMutations } from "vuex";
import { cartCount } from "@/api/cart.js";
import { getVerify, loginWeb, registerID, getUserInfo } from "@/api/login.js";
import { async } from "q";
export default {
  name: "login",
  data() {
    return {
      ruleForm: {
        user: "",
        password: "",
      },
      regForm: {
        tel: "",
        code: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        user: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      regRules: {
        // pass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      islogin: false,
      show: "login",
      activeName: "pwdLogin",
      registerVisible: true,
      forgotVisible: true,
      loading: false,
      loading1: false,
      loading2: false,
      phoneNumber: null,
      phoneNumber1: null,
      phoneNumber2: null,
      authCode: null,
      authCode1: null,
      authCode2: null,
      pwd: "",
      pwd1: "",
      pwd2: "",
      pwdAgain: "",
      pwdAgain1: "",
      showTime: false,
      showTime1: false,
      showTime2: false,
      time: 60,
      time1: 60,
      time2: 60,
      timer: null,
      timer1: null,
      timer2: null,
      read: false,
      relus: /^1[13456789]\d{9}$/,
    };
  },
  computed: {
    ...mapGetters([
      "loginVisible", // 登录注册弹窗开关
    ]),
  },
  methods: {
    ...mapMutations({
      setUserInfo: "SET_USERINFO", // 修改用户信息
      setCartNum: "SET_CARTNUM", // 修改购物车商品数量
    }),
    // 倒计时
    countDown() {
      this.showTime = true;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else {
          this.showTime = false;
          clearInterval(this.timer);
          this.time = 60;
        }
      }, 1000);
    },
    countDown1() {
      this.showTime1 = true;
      clearInterval(this.timer1);
      this.timer1 = setInterval(() => {
        if (this.time1 > 0) {
          this.time1--;
        } else {
          this.showTime1 = false;
          clearInterval(this.timer1);
          this.time1 = 60;
        }
      }, 1000);
    },
    countDown2() {
      this.showTime2 = true;
      clearInterval(this.timer2);
      this.timer2 = setInterval(() => {
        if (this.time2 > 0) {
          this.time2--;
        } else {
          this.showTime2 = false;
          clearInterval(this.timer2);
          this.time2 = 60;
        }
      }, 1000);
    },

    // 切换验证码登录
    codeLogin() {
      this.$message.warning("暂未接入短信登录");
      // this.activeName = 'codeLogin'
    },

    // 切换密码登录
    passwordLogin() {
      this.activeName = "pwdLogin";
    },

    // 登录获取验证码
    getCode() {
      if (this.ruleForm.phoneNumber === null) {
        return this.$message.warning("请输入手机号码");
      } else if (!this.relus.test(this.ruleForm.phoneNumber)) {
        return this.$message.warning("手机格式错误");
      }
      getVerify({
        phone: this.phoneNumber,
        type: "login", // bind绑定手机短信 login登陆短信 register注册短信
      }).then((res) => {
        if (res.status === 200) {
          this.$message.success("验证码发送成功");
          this.countDown();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 注册获取验证码
    getCode1() {
      if (this.regForm.tel === null) {
        return this.$message.warning("请输入手机号码");
      } else if (!this.relus.test(this.regForm.tel)) {
        return this.$message.warning("手机格式错误");
      }
      getVerify({
        phone: this.regForm.tel,
        type: "register",
      }).then((res) => {
        if (res.status === 200) {
          this.$message.success("验证码发送成功");
          this.countDown1();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    // 去注册
    toRegister() {
      this.show = "register";
    },

    // 忘记密码
    toForgot() {
      this.show = "forgot";
    },

    // 去登录
    toLogin() {
      this.show = "login";
    },

    // 登录
    login() {
      if (
        this.ruleForm.password.length < 4 ||
        this.ruleForm.password.length > 16
      ) {
        return this.$message.warning("请输入4至16位的密码");
      }
      this.loading = true;
      loginWeb({
        username: this.ruleForm.user,
        password: this.ruleForm.password,
      }).then(async (res) => {
        if (res.status === 200) {
          let seconds = res.data.expires_in;
          let expires = new Date(new Date() * 1 + seconds * 1000);
          Cookie.set("Yshop_token", res.data.token);
          Cookie.set("expires", expires);
          this.$message.success("登录成功");
          await this.getUserInfo();

          // this.getCartNum();
          // this.handleClose();
          // location.reload();
        } else {
          this.$message.warning("用户名或密码错误！");
        }
      });
      this.loading = false;
    },

    // 获取购物车商品数量
    async getCartNum() {
      var res = await cartCount();
      if (res.status === 200) {
        this.setCartNum(res.data.count);
      } else {
        this.$message.warning(res.msg);
      }
    },

    // 隐私协议是否已读
    select() {
      this.read = !this.read;
    },

    // 注册
    register() {
      if (!this.read) {
        return this.$message.warning("请先阅读YSHOP隐私条款");
      } else if (
        this.regForm.pass.length < 4 ||
        this.regForm.pass.length > 16
      ) {
        return this.$message.warning("请输入4到16位的密码");
      } else if (this.regForm.pass !== this.regForm.checkPass) {
        return this.$message.warning("两次密码不一致");
      }
      this.loading1 = true;
      registerID({
        account: this.regForm.tel,
        captcha: this.regForm.code,
        password: this.regForm.pass,
      }).then((res) => {
        if (res.status === 200) {
          this.$message.success("注册成功");
          setTimeout(() => {
            this.toLogin();
          }, 1000);
        } else {
          this.$message.warning(res.msg);
        }
      });
      this.loading1 = false;
    },

    // 修改密码
    getBack() {
      this.loading = true;
    },

    // 获取用户信息
    async getUserInfo() {
      var res = await getUserInfo();
      if (res.status === 200) {
        this.$store.commit("setLoginVisible", false);
        // this.$store.commit('setUser', res.data)
        // this.$store.commit('userInfo', res.data)
        this.$store.commit(
          "SET_USERINFO",
          res.data,
          new Date().getTime() + 3000
        );

        // this.setUserInfo(res.data);
        this.$router.go(0);
      }
    },

    // 关闭登录注册弹窗
    handleClose() {
      this.$store.commit("setLoginVisible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
>>>.el-dialog {
  .el-dialog__header {
    text-align: center;
    background-color: #409eff;

    .el-dialog__title {
      color: rgb(255, 255, 255);
      font-size: 18px;
      position: relative;
      top: -3px;
    }

    .el-icon-close {
      color: #ffffff;
    }
  }

  .el-dialog__body {
    .clause {
      .select {
        width: 16px;
        height: 16px;
        background-image: url("../../../static/images/wz@2x.png");
        background-size: 100% 100%;
      }

      .active {
        background-image: url("../../../static/images/zjxz@2x.png");
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue